import { Tooltip, TooltipContent, TooltipTrigger } from "@tracify/ui/tooltip";
import React from "react";
import InfoIcon from "@tracify/ui/info-icon";
import { cn } from "@lib/utils";

const OrganicTooltip = () => {
  return (
    <Tooltip>
      <TooltipTrigger>
        <InfoIcon className={cn("ml-1 h-4 w-4 text-muted-foreground")} />
      </TooltipTrigger>
      <TooltipContent>
        <p className="w-96">
          In general, organic is defined as users visiting your site from
          another page without any paid push marketing efforts from your end
          (&quot;naturally earned&quot;).{" "}
          <a
            href="https://knowledge.tracify.ai/en/articles/92685-what-is-the-difference-between-organic-traffic-and-direct-traffic"
            rel="noreferrer"
            target="_blank"
            className="underline"
          >
            Read more
          </a>
        </p>
      </TooltipContent>
    </Tooltip>
  );
};

export default OrganicTooltip;
